module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-1-Article.9623a4a7.webp";